module.exports = __webpack_public_path__ + "img/sub_manual_t.c06e3805.png";